import React, { useState, useEffect } from "react";
import {
  Box,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Flex,
  Icon,
  Text,
} from "@chakra-ui/react";
import { MdLocationOn, MdBolt } from "react-icons/md";
import { useLocation, useNavigate } from "react-router-dom";
import AvailableLocationsTable from "./components/AvailableLocationsTable";
import ActiveSessionsPanel from "./tab_panels/ActiveSessionsPanel";

const ChargingManagementScreen = () => {
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const location = useLocation();
  const navigation = useNavigate();

  const clickHandler = (x) => {
    if (x === 0) {
      navigation(`/admin/charging_management/locations`);
    } else if (x === 1) {
      navigation(`/admin/charging_management/active-sessions`);
    }
  };

  useEffect(() => {
    if (location.pathname === "/admin/charging_management/active-sessions") {
      setActiveTabIndex(1);
    } else if (location.pathname === "/admin/charging_management/locations") {
      setActiveTabIndex(0);
    }
  }, [location]);

  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <Tabs
        variant="unstyled"
        isLazy={true}
        index={activeTabIndex}
        style={{ marginTop: "20px" }}
      >
        <TabList
          gap={4}
          px={1}
          py={2}
          bg="rgba(255, 255, 255, 0.6)"
          backdropFilter="blur(12px)"
          borderRadius="xl"
          border="1px solid rgba(245, 125, 54, 0.15)"
          position="relative"
          overflow="hidden"
          _before={{
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            height: "100%",
            zIndex: 0,
            pointerEvents: "none",
          }}
        >
          <Tab
            _focus={{ boxShadow: "none" }}
            onClick={() => clickHandler(0)}
            borderRadius="lg"
            px={{ base: 3, md: 5 }}
            py={{ base: 2, md: 2.5 }}
            fontWeight="500"
            color="gray.600"
            position="relative"
            zIndex="1"
            _selected={{
              bg: "rgba(245, 125, 54, 0.15)",
              color: "#f57d36",
              fontWeight: "600",
              boxShadow: "0 2px 4px rgba(245, 125, 54, 0.1)",
            }}
            _hover={{
              bg: "rgba(245, 125, 54, 0.08)",
              color: "#f57d36",
            }}
          >
            <Flex align="center" gap={{ base: 1.5, md: 2 }}>
              <Icon as={MdLocationOn} boxSize={{ base: 4, md: 5 }} />
              <Text fontSize={{ base: "sm", md: "md" }}>Locations</Text>
            </Flex>
          </Tab>

          <Tab
            _focus={{ boxShadow: "none" }}
            onClick={() => clickHandler(1)}
            borderRadius="lg"
            px={{ base: 3, md: 5 }}
            py={{ base: 2, md: 2.5 }}
            fontWeight="500"
            color="gray.600"
            position="relative"
            zIndex="1"
            _selected={{
              bg: "rgba(245, 125, 54, 0.15)",
              color: "#f57d36",
              fontWeight: "600",
              boxShadow: "0 2px 4px rgba(245, 125, 54, 0.1)",
            }}
            _hover={{
              bg: "rgba(245, 125, 54, 0.08)",
              color: "#f57d36",
            }}
          >
            <Flex align="center" gap={{ base: 1.5, md: 2 }}>
              <Icon as={MdBolt} boxSize={{ base: 4, md: 5 }} />
              <Text fontSize={{ base: "sm", md: "md" }}>Active Sessions</Text>
            </Flex>
          </Tab>
        </TabList>
        <TabPanels>
          <TabPanel>
            <AvailableLocationsTable />
          </TabPanel>
          <TabPanel>
            <ActiveSessionsPanel />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};

export default ChargingManagementScreen;
